import styled from 'styled-components'
import { colors } from '../../theme'

export const Table = styled.table<{ size?: string }>`
  margin-top: 20px;
  text-align: center;
  background-color: ${colors.grey50};
  position: relative;
  border: 0;
  padding: 0;
  border-spacing: 0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  overflow: hidden;
  white-space: normal;
  width: 100%;

  tbody > tr:nth-child(even),
  th > th:nth-child(even) {
    background-color: ${colors.grey100};
  }
  tr td {
    font-size: 13px;
    text-align: left;
    padding: 20px;
  }
  .colPedido {
    text-align: left;
    width: 70%;
    overflow: hidden;
    white-space: normal;
    padding: 5px;
    padding-left: 20px;
  }
  .colPedidoCenter {
    text-align: center;
    width: 15%;
    overflow: hidden;
    white-space: normal;
    padding: 5px;
  }

  .col2 {
    text-align: left;
    width: 50%;
    overflow: hidden;
    white-space: normal;
  }

  .colPredictionDetails {
    text-align: left;
    width: 50%;
    overflow: hidden;
    white-space: normal;
  }
  .col3 {
    text-align: center;
    width: 30%;
    overflow: hidden;
    white-space: normal;
  }
  .colIcon {
    text-align: right;
  }
  .colVendas {
    text-align: left;
    width: 20px;
    overflow: hidden;
    white-space: normal;
  }
  .colVendas7 {
    text-align: left;
    width: 23%;
    overflow: hidden;
    white-space: normal;
  }

  .colVendas6 {
    text-align: center;
    width: 10%;
    overflow: hidden;
    white-space: normal;
  }
  .colAtivaInativa {
    padding-left: 60px;
    text-align: center;
    overflow: hidden;
    white-space: normal;
  }

  .itemTable {
    cursor: pointer;
  }
  td,
  th {
    border-bottom: 5px solid ${colors.surface};
  }
`

export const Thead = styled.thead<{
  spacing: string
  font: string
  vendas?: boolean
  text?: boolean
  title4?: boolean
  title5?: boolean
}>`
  /* Cabecalho SEM preenchimento, no mesmo desenho da mini-tabela do card de
     Previsoes: o verde deixou de ser cor de bloco e passou a ser so acento, e
     uma faixa cheia atravessando cada card competia com o conteudo. O peso 400
     tambem vem de la — em bold a linha voltava a pesar como faixa. */
  background: transparent;
  color: ${colors.azul2};
  font-weight: 400;
  font-size: ${({ font }) => font};
  text-align: left;

  tr {
    th:nth-child(2) {
      width: 15%;
      text-align: ${({ vendas }) => (vendas ? 'left' : 'center')};
    }
  }
  tr {
    th:nth-child(6) {
      padding-left: ${({ spacing }) => spacing};
      width: 15%;
    }
  }
  tr {
    th:nth-child(3) {
      width: 15%;
      text-align: ${({ text }) => (text ? 'left' : 'center')};
    }
  }
  tr {
    th:nth-child(7) {
      width: 15%;
      text-align: center;
    }
  }
  tr {
    th:nth-child(4) {
      width: 15%;
      text-align: ${({ title4 }) => (title4 ? 'left' : 'center')};
    }
  }
  tr {
    th:nth-child(8) {
      width: 15%;
      padding-right: 50px;
    }
  }
  tr {
    th:nth-child(5) {
      width: 15%;
      text-align: ${({ title5 }) => (title5 ? 'left' : 'center')};
    }
  }
  tr,
  th {
    padding: 10px 20px 10px 20px;
    font-size: 12px;
    /* O th do navegador e bold e vence a heranca do thead. */
    font-weight: 400;
  }
`
